<template>
    <div class='date-ellipsis'
        :style="{
            width
        }">
        <template v-if="dateCache.length > 0">
            <span v-if="dateCache.length <= getLen">{{ dateMsg }}</span>
            <el-popover v-else
                popper-class="__date-ellipsis-popper__"
                placement="top"
                trigger="hover"
                :content="`每月${dateCache.join('、')}日`">
                <span slot="reference">{{ dateMsg }}</span>
            </el-popover>
        </template>
    </div>
</template>

<script>
import { createComponent, ref } from '@vue/composition-api'

export default createComponent({
    props: {
        dateCache: {
            type: Array,
            default: () => []
        },
        width: {
            type: String,
            default: '100%'
        },
        maxWidth: {
            type: String,
            default: 'calc(100% - 45px)'
        }
    },

    computed: {
        getLen() {
            const oneBitLen = this.dateCache.filter(d => d.toString().length === 1).length
            return oneBitLen < 5 ? 8 : 9
        },

        sliceLen() {
            return this.getLen - 2
        },

        dateMsg() {
            if (this.dateCache.length <= this.getLen) {
                return `每月${this.dateCache.join('、')}日`
            } else {
                return `每月${this.dateCache.slice(0, this.sliceLen).join('、')}、...、${this.dateCache[this.dateCache.length - 1]}日`
            }
        }
    }
})
</script>

<style lang="scss">
.__date-ellipsis-popper__ {
    padding: 7px !important;
}
</style>

<style lang="scss" scoped>
.date-ellipsis {
    display: inline-flex;
    align-items: center;
    font-size: 14px;
    color: #333;
}
</style>
